import type { ReactNode } from 'react';

interface SummaryLineProps {
    label: string;
    value: ReactNode;
    minus?: boolean;
    strong?: boolean;
}

export function SummaryLine({ label, value, minus, strong }: SummaryLineProps) {
    return (
        <div
            className={`flex items-center justify-between gap-3 ${strong ? 'pt-2.5 border-t border-gray-200 mt-1' : ''}`}
        >
            <span
                className={`text-sm min-w-0 truncate ${strong ? 'font-bold text-gray-900' : 'text-gray-500'}`}
            >
                {label}
            </span>
            <span
                className={`tabular-nums shrink-0 max-w-[60%] truncate ${strong ? 'text-base font-bold text-gray-900' : `text-sm ${minus ? 'text-red-600' : 'text-gray-800'}`}`}
            >
                {value}
            </span>
        </div>
    );
}
